<template>
  <div class="row" v-if="panel.type">
    <div class="col-xs-12">
      <div class="form-group">
        <label for>Title Text</label>
        <input v-model="panel.title.text">
      </div>
    </div>
    <div class="col-xs-12">
      <div class="form-group">
        <label for>Title Font Colour</label>
        <select v-model="panel.title.colour">
          <option value>-- Select Colour --</option>
          <option v-for="(option, index) in colours.arr" :key="index" :value="option.value">{{option.label}}</option>
        </select>
      </div>
    </div>
    <div class="col-xs-12">
      <div class="form-group">
        <label>Auto Fit Text</label>
        <label class="switch">
          <input type="checkbox" v-model="panel.autofit">
          <span class="slider round"></span>
        </label>
      </div>
    </div>
    <div class="col-xs-12" v-if="!panel.autofit">
      <div class="form-group">
        <label for>Title Size</label>
        <input type="number" min="8" v-model="panel.title.size">
      </div>
    </div>
    <div class="col-xs-12" v-if="statType">
      <component v-if="statType" :is="statType" :panel="panel" :definition="definition"></component>
    </div>
  </div>
</template>

<script>
import colours from "../../../utils/colours";
import StatOptions from "./StatOptions";
import ListOptions from "./ListOptions";
import GraphOptions from "./GraphOptions";
export default {
  components: { StatOptions, ListOptions, GraphOptions },
  props: ["panel", "definition"],
  data() {
    return {
      colours
    };
  },
  computed: {
    statType() {
      switch (this.panel.type) {
        case "timepanel":
        case "stat":
          return "StatOptions";
          break;
        case "list":
          return "ListOptions";
          break;
        case "graph":
          return "GraphOptions";
          break;
        default:
          return "";
      }
    }
  }
};
</script>

<style>
</style>
